<script lang="ts">
	import { format } from '../../../../services/i18n';
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { localReq, postReq } from '../../../../services/http';
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
	import { calibrate_roller } from '../../../../helpers/requests/calibrate_cover';
	import { Alert, Button, Toggle, Checkbox, Text, toast } from '@Shelly/shelly-design-system';
	import ModalPrompt from '../../../../components/ModalPrompt.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device;

	const id = real_id(device.id);
	let showModal = false;
	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	let statusStore = getDeviceStatus(id);
	let status = $statusStore;

	let checked: boolean;
	let cache: boolean;

	$: if (typeof settings?.rollers?.[device.channel]?.positioning === 'boolean' && !loading) {
		if (cache === undefined || cache === checked) {
			checked = settings.rollers[device.channel].positioning;
			cache = checked;
		}
	}

	let loading = false;

	let localIp = get_local_ip(id);

	const enableDisablePosCtrls = async () => {
		checked = !checked;
		if ($showNewLayout) {
			sentRequest();
		}
	};

	const sentRequest = async () => {
		if (cache !== checked) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/roller/0`, 'post', {
					positioning: checked ? 1 : 0,
				});
			} else {
				res = await postReq(`/device/relay/roller/settings/positioning`, {
					id: device.id,
					roller_id: device.channel,
					positioning: checked ? 1 : 0,
				});
			}

			if (res.isok) {
				settings.rollers[device.channel].positioning = checked;
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title: checked
						? $format('position_control_enable_scc_toast')
						: $format('position_control_disable_scc_toast') ||
							`Positioning controls were ${checked ? 'enabled' : 'disabled'}.`,
				});
				cache = checked;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				checked = cache;
			}
			loading = false;
		}
	};

	let props = {
		// TODO add translation label_confirmation
		title: `${$format('button_calibrate')} ${$format('process_device')}?`,
		text: $format('calibration_msg', {
			default: 'Calibration ensures accurate performance by adjusting the device’s settings.',
		}),
		button_1: $format('button_calibrate'),
		button_2: $format('button_cancel'),
		callback: () => calibrate_roller(device, status, localIp, devices_status),
	};
</script>

{#if $showNewLayout}
	<Toggle size="m" class="mb-s-plus" {checked} on:click={enableDisablePosCtrls} id="checkbox-yadp8t3">
		{$format('label_enable')}
	</Toggle>
	{#if checked}
		<Alert class="mb-s" heading={$format('enable_device_calibration')} />
		<Button size="m" variant="secondary" width="full" on:click={() => (showModal = true)}
			>{$format('button_calibrate')}</Button
		>
	{/if}
{:else}
	<Checkbox size="m" class="mb-s" {checked} on:click={enableDisablePosCtrls} id="checkbox-yadp8t3"
		>{$format('label_enable')}</Checkbox
	>
	<Button {loading} size="m" width="full" class="mb-s" on:click={sentRequest}
		>{$format('button_save')}</Button
	>
	{#if checked}
		<Text styleType="body-small" class="mb-s">{$format('enable_device_calibration')}</Text>
		<Button size="m" variant="secondary" width="full" on:click={() => (showModal = true)}
			>{$format('button_calibrate')}</Button
		>
	{/if}
{/if}
{#if showModal}
	<ModalPrompt bind:showModal {props}>
		<Alert
			class="mt-m"
			type="warning"
			heading={$format('calibration_process_alert', {
				default:
					'Note that during or after the process may temporarily disconnect or change behavior.',
			})}
		/>
	</ModalPrompt>
{/if}
